export enum ReCaptchaAction {
  GETTING_STARTED = "REGISTER",
  CONTACT_US = "CONTACTUS",
}
